import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export function setAdminToken(token) {
  if (token) {
    localStorage.setItem("oz_admin_token", token);
  } else {
    localStorage.removeItem("oz_admin_token");
  }
}

export function getAdminToken() {
  return localStorage.getItem("oz_admin_token");
}

api.interceptors.request.use((config) => {
  const t = getAdminToken();
  if (t && config.url && config.url.startsWith("/admin")) {
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});
